import { ConsumableCard } from "../../../components/consumables/consumableCard/ConsumableCard"
import { translations } from "../../../configs/translations"
import { useStore } from "../../../store/store"

interface Props {
    fuel: number
    nitro: number
}

export const ConsumablesShowMenu = ({ fuel, nitro }: Props) => {
    const language = useStore(state => state.language) as keyof typeof translations
    const t = translations[language]

    return (
        <>
            <div className='consumable-menu-container show-in-race'>
                <div className='consumable-menu show-in-race'>
                    <ConsumableCard
                        type="fuel"
                        text={fuel.toFixed(0) + t.liters_short}
                    />
                    <ConsumableCard
                        type="nitro"
                        text={nitro.toFixed(0) + '%'}
                    />
                </div>
            </div>
        </>
    )
}